var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexColumn"},[_c('img',{staticStyle:{"width":"70%"},attrs:{"src":_vm.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }